import { useState } from 'react';

export default function ShareButton({ title, url, style = {} }) {
  const [copied, setCopied] = useState(false);

  const handleShare = async (e) => {
    e.stopPropagation();
    const fullUrl = `${window.location.origin}${url}`;

    if (navigator.share) {
      try {
        await navigator.share({ title, url: fullUrl });
      } catch (err) {
        if (err.name !== 'AbortError') copyFallback(fullUrl);
      }
    } else {
      copyFallback(fullUrl);
    }
  };

  const copyFallback = (fullUrl) => {
    navigator.clipboard.writeText(fullUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <button
      onClick={handleShare}
      title="Share article"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.3rem',
        padding: '0.25rem 0.6rem',
        fontSize: '0.78rem',
        fontWeight: '600',
        backgroundColor: copied ? '#d4edda' : '#f4f4f4',
        color: copied ? '#155724' : '#555',
        border: `1px solid ${copied ? '#c3e6cb' : '#ddd'}`,
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {copied ? '✓ Copied!' : '↗ Share'}
    </button>
  );
}
